<h4 *ngIf="title">{{title}}</h4>
<ng-template [ngIf]="beniImmobiliForm">
<form #f="ngForm" [formGroup]="beniImmobiliForm" (ngSubmit)="update();">
	<div class="row">
		<div comboModInput class="col-sm-4" [mandatory]="true"
			[labelInput]="'Tipo catasto'" formControlName="tipoCatasto"
			[objectReference]="formBeneImmobile.tipoCatasto"
			(onReturn)="formBeneImmobile.tipoCatasto = $event"
			[ngModel]="formBeneImmobile.tipoCatasto"
			[optionsCombo] ="tipoCatastoOptions"
			[control]="beniImmobiliForm.controls['tipoCatasto']"></div>
		<div
			textInputCurrency [control]="beniImmobiliForm.controls['valoreBene']"
			[mandatory]="true" class="col-sm-4"
			[location]="'SezioneBeniImmobili'" [labelInput]="'Valore del bene'"
			formControlName="valoreBene" [(ngModel)]="formBeneImmobile.valore"></div>

		<div checkBoxRadio class="col-sm-4"
			[labelInput]="'Nuda propriet&agrave;'"
      [idInput]="inserimento ? 'nudaProprieta-ins' : 'nudaProprieta-mod'"
			formControlName="nudaProprieta"
			[objectReference]="formBeneImmobile.nudaProprieta"
			(onReturn)="formBeneImmobile.nudaProprieta = $event"></div>
	</div>
	<div class="row">
		<div checkBoxRadio class="col-sm-6" [labelInput]="'Ipoteca'"
      [idInput]="inserimento ? 'ipoteca-ins' : 'ipoteca-mod'"
      formControlName="ipoteca"
			[objectReference]="formBeneImmobile.ipoteca"
			(onReturn)="changedIpoteca($event)"></div>

		<div textInputCurrency class="col-sm-6" [control]="beniImmobiliForm.controls['valoreIpoteca']"
			[labelInput]="'Valore ipoteca'" [location]="'SezioneBeniImmobili'"
			[submitPending]="!formBeneImmobile.ipoteca"
			formControlName="valoreIpoteca" [(ngModel)]="formBeneImmobile.valoreIpoteca"></div>

<!-- 		<div textInput class="col-sm-6" -->
<!-- 			[labelInput]="'Valore ipoteca'" -->
<!-- 			[control]="beniImmobiliForm.controls['valoreIpoteca']" -->
<!-- 			formControlName="valoreIpoteca" -->
<!-- 			[(ngModel)]="formBeneImmobile.valoreIpoteca"></div> -->

	</div>
	<div class="row">
		<div textAreaInput class="col-sm-12"
			[labelInput]="'Descrizione del bene'"
			formControlName="descrizioneBene" [mandatory]="true"
			[(ngModel)]="formBeneImmobile.descrizione"></div>
	</div>
	<div class="row container_fieldset">
		<fieldset class="form-group">
			<legend>Ubicazione</legend>
			<div textInput class="col-sm-4" [labelInput]="'Via'"
				[control]="beniImmobiliForm.controls['viaUbicazione']"
				formControlName="viaUbicazione"
				[(ngModel)]="formBeneImmobile.ubicazione.via"></div>
			<div textInput class="col-sm-4" [labelInput]="'Civico'"
				[control]="beniImmobiliForm.controls['civicoUbicazione']"
				formControlName="civicoUbicazione"
				[(ngModel)]="formBeneImmobile.ubicazione.civico"></div>
			<div naturalNumberInput class="col-sm-4" [labelInput]="'Cap'" [maxLength]="'5'"
				[control]="beniImmobiliForm.controls['capUbicazione']"
				formControlName="capUbicazione" [checkFormat]="true"
				[(ngModel)]="formBeneImmobile.ubicazione.cap"></div>
			<div comboModInput class="col-sm-4"
				(change)="changeProvincia(formBeneImmobile.ubicazione.provincia.id)"
				[labelInput]="'Provincia'" formControlName="provinciaUbicazione"
				[objectReference]="formBeneImmobile.ubicazione.provincia"
				(onReturn)="formBeneImmobile.ubicazione.provincia = $event"
				[optionsCombo] ="provinceOptions"></div>
			<div comboModInput class="col-sm-4" [labelInput]="'Comune'"
				formControlName="cittaUbicazione"
				[objectReference]="formBeneImmobile.ubicazione.localita"
				(onReturn)="formBeneImmobile.ubicazione.localita = $event"
				[optionsCombo] ="comuniOptions"></div>
			<div textInput class="col-sm-4" [labelInput]="'Nazione'"
				[control]="beniImmobiliForm.controls['nazioneUbicazione']"
				formControlName="nazioneUbicazione"
				[(ngModel)]="formBeneImmobile.ubicazione.nazione"></div>
		</fieldset>
	</div>
	<div class="row container_fieldset"
		*ngIf="formBeneImmobile.tipoCatasto && formBeneImmobile.tipoCatasto.label == 'Fabbricati'">
		<fieldset class="form-group">
			<legend>Dati catasto fabbricati</legend>

				<div textInput class="col-sm-4" [labelInput]="'Sezione'"
					[control]="beniImmobiliForm.controls['sezione']"
					formControlName="sezione"
					[(ngModel)]="formBeneImmobile.datiCatastaliBase.sezione"></div>
				<div textInput class="col-sm-4" [labelInput]="'Foglio'"
					[control]="beniImmobiliForm.controls['foglio']"
					formControlName="foglio"
					[(ngModel)]="formBeneImmobile.datiCatastaliBase.foglio"></div>
				<div textInput class="col-sm-4" [labelInput]="'Particella'"
					[control]="beniImmobiliForm.controls['particella']"
					formControlName="particella"
					[(ngModel)]="formBeneImmobile.datiCatastaliBase.particella"></div>

				<div textInput class="col-sm-4" [labelInput]="'Subparticella'"
					[control]="beniImmobiliForm.controls['subparticella']"
					formControlName="subparticella"
					[(ngModel)]="formBeneImmobile.datiCatastaliBase.subParticella"></div>
				<div textInput class="col-sm-4" [labelInput]="'Subalterno'"
					[control]="beniImmobiliForm.controls['subalterno']"
					formControlName="subalterno"
					[(ngModel)]="formBeneImmobile.datiCatastaliBase.subalterno"></div>
				<div textInput class="col-sm-4" [labelInput]="'Subalterno 2'"
					[control]="beniImmobiliForm.controls['subalterno2']"
					formControlName="subalterno2"
					[(ngModel)]="formBeneImmobile.datiCatastaliBase.subalterno2"></div>

				<div textInput class="col-sm-4" [labelInput]="'Graffato'"
					[control]="beniImmobiliForm.controls['graffato']"
					formControlName="graffato"
					[(ngModel)]="formBeneImmobile.datiCatastaliBase.graffato"></div>
				<div textInputCurrency class="col-sm-4" [labelInput]="'Zona censuaria'"
					[control]="beniImmobiliForm.controls['zonaCensuaria']" [location]="'SezioneEconomica'"
					formControlName="zonaCensuaria" [isNaturalNumber]="true"
					[(ngModel)]="formBeneImmobile.datiCatastaliUrbanoExtra.zonaCensuaria"></div>
				<div textInput class="col-sm-4" [labelInput]="'Categoria'"
					[control]="beniImmobiliForm.controls['categoria']"
					formControlName="categoria"
					[(ngModel)]="formBeneImmobile.datiCatastaliUrbanoExtra.categoria"></div>

				<div textInputCurrency class="col-sm-4" [labelInput]="'Classe'" [location]="'SezioneEconomica'"
					[control]="beniImmobiliForm.controls['classe']"
					formControlName="classe" [isNaturalNumber]="true"
					[(ngModel)]="formBeneImmobile.datiCatastaliBase.classe"></div>
				<div textInputCurrency class="col-sm-4" [labelInput]="'Diritti reali %'"
					[control]="beniImmobiliForm.controls['quota']" [location]="'SezioneEconomica'"
					formControlName="quota" [maxValue]="100"
					[(ngModel)]="formBeneImmobile.datiCatastaliBase.quota"></div>
				<div comboModInput class="col-sm-4"
					[(ngModel)]="formBeneImmobile.datiCatastaliBase.tipoDirittoReale"
					[control]="beniImmobiliForm.controls['tipoDirittoReale']"
					[labelInput]="'Tipo diritto reale'" formControlName="tipoDirittoReale"
					[objectReference]="formBeneImmobile.datiCatastaliBase.tipoDirittoReale"
					(onReturn)="formBeneImmobile.datiCatastaliBase.tipoDirittoReale = $event"
					[optionsCombo] ="tipoDirittoRealeOptions"></div>

				<div textInputCurrency class="col-sm-4" [labelInput]="'Consistenza'"
					[control]="beniImmobiliForm.controls['consistenza']" [location]="'SezioneEconomica'"
					formControlName="consistenza"
					[(ngModel)]="formBeneImmobile.datiCatastaliUrbanoExtra.consistenza"></div>
				<div textInput class="col-sm-4" [labelInput]="'Unit&agrave; di misura'"
					[control]="beniImmobiliForm.controls['unitaMisura']"
					formControlName="unitaMisura"
					[(ngModel)]="formBeneImmobile.datiCatastaliUrbanoExtra.unitaMisura"></div>
				<div textInputCurrency class="col-sm-4" [labelInput]="'Rendita'"
					[control]="beniImmobiliForm.controls['rendita']" [location]="'SezioneEconomica'"
					formControlName="rendita"
					[(ngModel)]="formBeneImmobile.datiCatastaliUrbanoExtra.rendita"></div>

				<div textInput class="col-sm-3" [labelInput]="'Edificio'"
					[control]="beniImmobiliForm.controls['edificio']"
					formControlName="edificio"
					[(ngModel)]="formBeneImmobile.datiCatastaliUrbanoExtra.edificio"></div>
				<div textInput class="col-sm-3" [labelInput]="'Piano'"
					[control]="beniImmobiliForm.controls['pianoFabbricato']"
					formControlName="pianoFabbricato"
					[(ngModel)]="formBeneImmobile.datiCatastaliUrbanoExtra.piano"></div>
				<div textInput class="col-sm-3" [labelInput]="'Interno'"
					[control]="beniImmobiliForm.controls['internoFabbricato']"
					formControlName="internoFabbricato"
					[(ngModel)]="formBeneImmobile.datiCatastaliUrbanoExtra.interno"></div>
				<div textInput class="col-sm-3" [labelInput]="'Scala'"
					[control]="beniImmobiliForm.controls['scalaFabbricato']"
					formControlName="scalaFabbricato"
					[(ngModel)]="formBeneImmobile.datiCatastaliUrbanoExtra.scala"></div>
		</fieldset>
	</div>
	<div class="row container_fieldset"
		*ngIf="formBeneImmobile.tipoCatasto && formBeneImmobile.tipoCatasto.label == 'Terreni'">
		<fieldset class="form-group">
			<legend>Dati catasto terreni</legend>
			<div textInput class="col-sm-4" [labelInput]="'Sezione'"
				[control]="beniImmobiliForm.controls['sezione']"
				formControlName="sezione"
				[(ngModel)]="formBeneImmobile.datiCatastaliBase.sezione"></div>
			<div textInput class="col-sm-4" [labelInput]="'Foglio'"
				[control]="beniImmobiliForm.controls['foglio']"
				formControlName="foglio"
				[(ngModel)]="formBeneImmobile.datiCatastaliBase.foglio"></div>
			<div textInput class="col-sm-4" [labelInput]="'Particella'"
				[control]="beniImmobiliForm.controls['particella']"
				formControlName="particella"
				[(ngModel)]="formBeneImmobile.datiCatastaliBase.particella"></div>

			<div textInput class="col-sm-4" [labelInput]="'Subparticella'"
				[control]="beniImmobiliForm.controls['subparticella']"
				formControlName="subparticella"
				[(ngModel)]="formBeneImmobile.datiCatastaliBase.subParticella"></div>
			<div textInput class="col-sm-4" [labelInput]="'Subalterno'"
				[control]="beniImmobiliForm.controls['subalterno']"
				formControlName="subalterno"
				[(ngModel)]="formBeneImmobile.datiCatastaliBase.subalterno"></div>
			<div textInput class="col-sm-4" [labelInput]="'Subalterno 2'"
				[control]="beniImmobiliForm.controls['subalterno2']"
				formControlName="subalterno2"
				[(ngModel)]="formBeneImmobile.datiCatastaliBase.subalterno2"></div>

			<div textInput class="col-sm-4" [labelInput]="'Graffato'"
				[control]="beniImmobiliForm.controls['graffato']"
				formControlName="graffato"
				[(ngModel)]="formBeneImmobile.datiCatastaliBase.graffato"></div>

			<div textInput class="col-sm-4" [labelInput]="'Qualita'"
				[control]="beniImmobiliForm.controls['qualita']"
				formControlName="qualita"
				[(ngModel)]="formBeneImmobile.datiCatastaliTerreniExtra.qualita"></div>
			<div textInputCurrency class="col-sm-4" [labelInput]="'Classe'" [location]="'SezioneEconomica'"
				[control]="beniImmobiliForm.controls['classe']"
				formControlName="classe" [isNaturalNumber]="true"
				[(ngModel)]="formBeneImmobile.datiCatastaliBase.classe"></div>

			<div textInputCurrency class="col-sm-4" [labelInput]="'Diritti reali %'"
				[control]="beniImmobiliForm.controls['quota']" [location]="'SezioneEconomica'"
				formControlName="quota" [maxValue]="100"
				[(ngModel)]="formBeneImmobile.datiCatastaliBase.quota"></div>
			<div comboModInput class="col-sm-4"
				[(ngModel)]="formBeneImmobile.datiCatastaliBase.tipoDirittoReale"
				[control]="beniImmobiliForm.controls['tipoDirittoReale']"
				[labelInput]="'Tipo diritto reale'" formControlName="tipoDirittoReale"
				[objectReference]="formBeneImmobile.datiCatastaliBase.tipoDirittoReale"
				(onReturn)="formBeneImmobile.datiCatastaliBase.tipoDirittoReale = $event"
				[optionsCombo] ="tipoDirittoRealeOptions"></div>
			<div textInputCurrency class="col-sm-4" [labelInput]="'Superficie'"
				[control]="beniImmobiliForm.controls['superficieTerreno']"
				formControlName="superficieTerreno" [location]="'SezioneEconomica'"
				[(ngModel)]="formBeneImmobile.datiCatastaliTerreniExtra.superficie"></div>

			<div textInput class="col-sm-4" [labelInput]="'Unit&agrave; di misura'"
				[control]="beniImmobiliForm.controls['unitaMisuraTerreno']"
				formControlName="unitaMisuraTerreno"
				[(ngModel)]="formBeneImmobile.datiCatastaliTerreniExtra.unitaMisura"></div>
			<div textInputCurrency class="col-sm-4" [labelInput]="'Reddito dominicale'"
				[control]="beniImmobiliForm.controls['redditoDominicale']"
				formControlName="redditoDominicale" [location]="'SezioneEconomica'"
				[(ngModel)]="formBeneImmobile.datiCatastaliTerreniExtra.redditoDominicale"></div>
			<div textInputCurrency class="col-sm-4" [labelInput]="'Reddito agrario'"
				[control]="beniImmobiliForm.controls['redditoAgrario']"
				formControlName="redditoAgrario" [location]="'SezioneEconomica'"
				[(ngModel)]="formBeneImmobile.datiCatastaliTerreniExtra.redditoAgrario"></div>
		</fieldset>
	</div>
	<div class="row container_fieldset">
		<fieldset class="form-group">
			<legend>Dati denuncia</legend>
			<div comboModInput class="col-sm-3" [labelInput]="'Tipologia'"
				formControlName="tipologiaDenuncia"
				[objectReference]="formBeneImmobile.datiDenuncia.tipoDenuncia"
				(onReturn)="formBeneImmobile.datiDenuncia.tipoDenuncia = $event"
				[optionsCombo] ="tipoDenunciaOptions"
				[ngModel]="formBeneImmobile.datiDenuncia.tipoDenuncia"></div>
			<div textInput class="col-sm-3"
				[labelInput]="'Numero'" [checkFormat]="true"
				[control]="beniImmobiliForm.controls['numeroDenuncia']"
				formControlName="numeroDenuncia"
				[(ngModel)]="formBeneImmobile.datiDenuncia.numero"></div>
			<div naturalNumberInput class="col-sm-3" [labelInput]="'Anno'" [checkFormat]="true"
				[control]="beniImmobiliForm.controls['annoDenuncia']"
				formControlName="annoDenuncia" [checkFormat]="true"
				[(ngModel)]="formBeneImmobile.datiDenuncia.anno"></div>
			<div datePickerInput class="col-sm-3" [labelInput]="'Data'"
				formControlName="dataDenuncia"
				[(ngModel)]="formBeneImmobile.datiDenuncia.dataDenuncia"></div>

		</fieldset>
	</div>
	<div class="row container_fieldset">
		<fieldset class="form-group">
			<legend>Istanza di vendita</legend>
			<div checkBoxRadio class="col-sm-3" [labelInput]="'Vendita'"
        [idInput]="inserimento ? 'vendita-ins' : 'vendita-mod'"
				formControlName="vendita"
				[objectReference]="formBeneImmobile.istanzaVendita.vendita"
				(onReturn)="changedVendita($event)"></div>
			<div datePickerInput class="col-sm-3" [labelInput]="'Data'"
				formControlName="dataIstanzaVendita"
				[submitPending]="!formBeneImmobile.istanzaVendita.vendita"
				[(ngModel)]="formBeneImmobile.istanzaVendita.dataIstanza"></div>
			<div textInput class="col-sm-3" [labelInput]="'Acquirente'"
				[control]="beniImmobiliForm.controls['acquirenteIstanzaVendita']"
				formControlName="acquirenteIstanzaVendita"
				[submitPending]="!formBeneImmobile.istanzaVendita.vendita"
				[(ngModel)]="formBeneImmobile.istanzaVendita.acquirente"></div>
			<div
				textInputCurrency [control]="beniImmobiliForm.controls['ricavatoIstanzaVendita']"
				class="col-sm-3" [location]="'SezioneBeniImmobili'"
				[labelInput]="'Ricavato'" formControlName="ricavatoIstanzaVendita"
				[submitPending]="!formBeneImmobile.istanzaVendita.vendita"
				[(ngModel)]="formBeneImmobile.istanzaVendita.ricavato"></div>
		</fieldset>
	</div>
	<div class="row container_fieldset">
		<fieldset class="form-group">
			<legend>Istanza di assegnazione</legend>
			<div checkBoxRadio class="col-sm-6"
				[labelInput]="'Assegnato'"
        [idInput]="inserimento ? 'assegnato-ins' : 'assegnato-mod'"
				formControlName="assegnato"
				[objectReference]="formBeneImmobile.istanzaAssegnazione.assegnato"
				(onReturn)="changedAssegnazione($event)"></div>
			<div datePickerInput class="col-sm-6"
				[control]="beniImmobiliForm.controls['dataIstanzaAssegnazione']"
				[labelInput]="'Data'" formControlName="dataIstanzaAssegnazione"
				[submitPending]="!formBeneImmobile.istanzaAssegnazione.assegnato"
				[(ngModel)]="formBeneImmobile.istanzaAssegnazione.dataIstanza"></div>
		</fieldset>
	</div>
	<div class="row">
		<div textAreaInput class="col-sm-12" [labelInput]="'Note'"
			formControlName="note" [(ngModel)]="formBeneImmobile.note"></div>
	</div>
	<div class="row">
		<p class="col-sm-3 col-xs-6">
			<button type="button" class="btn btn-outline-secondary btn-block" (click)="createForm();">Reset</button>
		</p>
		<p submitButton
			class="col-sm-3 col-xs-6 col-sm-offset-6"
			[disabled]='!beniImmobiliForm.valid'
			[labelButton]="inserimento? 'Inserisci e salva' : 'Salva'">
	</div>
</form>
</ng-template>
